export const getChangeTextColor = (change: number) => {
  return change > 0 ? 'text-semantic_green' : change < 0 ? 'text-semantic_red' : 'text-on_surface';
};
